module.exports = __webpack_public_path__ + "assets/img/doc_nfc_app_create.a039c484.png";